var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAfternoon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFD347"
    },
    cx: 255.997,
    cy: 255.997,
    r: 144.824
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD347"
    },
    d: "M256,56.849c-4.273,0-7.737-3.463-7.737-7.737V7.737C248.263,3.463,251.727,0,256,0 s7.737,3.463,7.737,7.737v41.376C263.737,53.386,260.273,56.849,256,56.849z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD347"
    },
    d: "M152.563,84.568c-2.674,0-5.274-1.387-6.707-3.869l-20.687-35.832 c-2.136-3.7-0.869-8.432,2.832-10.569c3.701-2.134,8.432-0.87,10.569,2.832l20.687,35.832c2.136,3.7,0.869,8.432-2.832,10.569 C155.206,84.234,153.876,84.568,152.563,84.568z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD347"
    },
    d: "M76.823,160.294c-1.312,0-2.643-0.334-3.861-1.038L37.13,138.569 c-3.7-2.136-4.968-6.868-2.832-10.569c2.136-3.701,6.868-4.967,10.569-2.832l35.832,20.687c3.7,2.136,4.968,6.868,2.832,10.569 C82.097,158.907,79.497,160.294,76.823,160.294z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD347"
    },
    d: "M49.112,263.737H7.737C3.464,263.737,0,260.274,0,256s3.464-7.737,7.737-7.737h41.376 c4.273,0,7.737,3.463,7.737,7.737S53.385,263.737,49.112,263.737z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD347"
    },
    d: "M41.005,387.869c-2.674,0-5.274-1.387-6.707-3.869c-2.136-3.7-0.869-8.432,2.832-10.569 l35.832-20.687c3.7-2.134,8.432-0.87,10.569,2.832c2.136,3.7,0.869,8.432-2.832,10.569l-35.832,20.687 C43.648,387.535,42.317,387.869,41.005,387.869z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD347"
    },
    d: "M131.862,478.74c-1.312,0-2.643-0.334-3.861-1.038c-3.7-2.136-4.968-6.868-2.832-10.569 l20.687-35.832c2.136-3.701,6.868-4.967,10.569-2.832c3.7,2.136,4.968,6.868,2.832,10.569l-20.687,35.832 C137.136,477.352,134.536,478.74,131.862,478.74z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD347"
    },
    d: "M256,512c-4.273,0-7.737-3.463-7.737-7.737v-41.376c0-4.274,3.464-7.737,7.737-7.737 s7.737,3.463,7.737,7.737v41.376C263.737,508.537,260.273,512,256,512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD347"
    },
    d: "M380.138,478.74c-2.674,0-5.274-1.387-6.707-3.869l-20.687-35.832 c-2.136-3.7-0.869-8.432,2.832-10.569c3.7-2.134,8.432-0.87,10.569,2.832l20.687,35.832c2.136,3.7,0.869,8.432-2.832,10.569 C382.781,478.406,381.451,478.74,380.138,478.74z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD347"
    },
    d: "M470.995,387.869c-1.312,0-2.643-0.334-3.861-1.038l-35.832-20.687 c-3.7-2.136-4.968-6.868-2.832-10.569c2.136-3.701,6.868-4.967,10.569-2.832l35.832,20.687c3.7,2.136,4.968,6.868,2.832,10.569 C476.269,386.481,473.669,387.869,470.995,387.869z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD347"
    },
    d: "M504.263,263.737h-41.376c-4.273,0-7.737-3.463-7.737-7.737s3.464-7.737,7.737-7.737h41.376 c4.273,0,7.737,3.463,7.737,7.737S508.536,263.737,504.263,263.737z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD347"
    },
    d: "M435.177,160.294c-2.674,0-5.274-1.387-6.707-3.869c-2.136-3.7-0.869-8.432,2.832-10.569 l35.832-20.687c3.7-2.134,8.432-0.87,10.569,2.832c2.136,3.7,0.869,8.432-2.832,10.569l-35.832,20.687 C437.82,159.96,436.489,160.294,435.177,160.294z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD347"
    },
    d: "M359.437,84.568c-1.312,0-2.643-0.334-3.861-1.038c-3.7-2.136-4.968-6.868-2.832-10.569 l20.687-35.832c2.136-3.701,6.868-4.967,10.569-2.832c3.7,2.136,4.968,6.868,2.832,10.569l-20.687,35.832 C364.711,83.181,362.11,84.568,359.437,84.568z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBE31"
    },
    d: "M256,111.18c-5.242,0-10.418,0.286-15.516,0.828c72.685,7.743,129.303,69.252,129.303,143.991 s-56.619,136.249-129.303,143.992c5.098,0.544,10.273,0.828,15.516,0.828c79.982,0,144.82-64.838,144.82-144.82 S335.983,111.18,256,111.18z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAfternoon);
export default __webpack_public_path__ + "static/media/afternoon.77fe41eab4aef3738da13fb69d72f35c.svg";
export { ForwardRef as ReactComponent };